import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-spinkit';
import cx from 'classnames';

import Money from '../../components/Money';
import { flag, handler } from '../../shapes';
import { nullFunc } from '../../utils/helpers';
import ErrorMsg from '../../components/ErrorMsg';

const ReedemCode = ({
  handleSubmit,
  isFetching,
  error,
  isValid,
  promoCode,
  onChange,
  submitEnabled,
  hasLoyaltyProgram,
  hasPromotions,
  giftCardEnabled,
  inputDisabled,
  remainingGiftCardBalance,
  hasGiftCardBalance,
}) => {
  const promoLabel = (() => {
    const labels = [];
    if (hasLoyaltyProgram) labels.push('Loyalty');
    if (giftCardEnabled) labels.push('Gift Card');
    labels.push('Promo');
    const separator = (labels.length > 2) ? '/' : ' or ';
    return `${labels.join(separator)}`;
  })();

  if (!hasPromotions) return null;

  return (
    <form
      className="c-payment-modal-promo"
      onSubmit={handleSubmit}
    >
      <div className="u-mb-- u-mt-- u-hide-for-small-and-down">
        { error && <ErrorMsg>{error}</ErrorMsg> }
        {
          hasGiftCardBalance && (
            <div className="c-heading epsilon u-type--bold">
              <span>Remaining balance:</span>
              &nbsp;
              <Money>{remainingGiftCardBalance}</Money>
            </div>
          )
        }
        {
          !error && !hasGiftCardBalance && <div style={{ height: '20px' }} />
        }
      </div>
      <div className="u-flex">
        <input
          className={cx('c-payment-modal-promo__input', { 'c-payment-modal-promo__input--empty': !promoCode })}
          value={promoCode}
          onChange={onChange}
          disabled={inputDisabled}
          placeholder={promoLabel}
        />
        <button
          className="c-payment-modal-promo__submit"
          disabled={!submitEnabled || isFetching}
          type="submit"
        >
          { isValid && 'Change' }
          { (!isValid && !isFetching) && 'Redeem' }
          { isFetching && <Spinner name="three-bounce" className="c-checkout-modal__spinner" noFadeIn /> }
        </button>
      </div>
      <div className="u-mt-- u-mb-- u-hide-for-medium-and-up">
        { error && <ErrorMsg>{error}</ErrorMsg> }
        {
          hasGiftCardBalance && (
            <div className="c-heading epsilon u-type--bold">
              <span>Remaining balance:</span>
              &nbsp;
              <Money>{remainingGiftCardBalance}</Money>
            </div>
          )
        }
      </div>
    </form>
  );
};
ReedemCode.propTypes = {
  handleSubmit: handler,
  isFetching: flag,
  error: PropTypes.string,
  isValid: flag,
  promoCode: PropTypes.string,
  onChange: handler,
  submitEnabled: flag.isRequired,
  hasLoyaltyProgram: flag,
  hasPromotions: flag,
  giftCardEnabled: flag,
  inputDisabled: flag,
  remainingGiftCardBalance: PropTypes.number.isRequired,
  hasGiftCardBalance: flag.isRequired,
};
ReedemCode.defaultProps = {
  hasLoyaltyProgram: false,
  hasPromotions: true,
  handleSubmit: nullFunc,
  isFetching: false,
  error: '',
  isValid: false,
  promoCode: '',
  onChange: nullFunc,
  giftCardEnabled: false,
  inputDisabled: false,
};

export default ReedemCode;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PaymenModalReedemCode.jsx